import axios from '@/utils/request'

/**
 * 停车记录
 */
const getParkList = (params, options) => axios({
  url: 'park/record',
  params,
  options
})

/**
 * 导出停车记录Execl
 */
const getParkExcel = params => axios({
  url: 'park/record/excel',
  responseType: 'arraybuffer',
  params
})

/**
 * 停车券列表
 */
const getParkCouponList = (data) => axios({
  url: 'park/coupon',
  data
})

/**
 * 导出停车券发送记录excel
 */
const getParkCouponExcel = () => axios({
  url: 'park/coupon/send/excel',
  responseType: 'arraybuffer'
})

/**
 * 停车券发送记录列表
 */
const getParkDetails = (params, options) => axios({
  url: 'park/coupon/send',
  params,
  options
})

/**
 * 发送停车券
 */
const postParkCoupon = (data) => axios({
  url: 'park/coupon/send',
  method: 'post',
  data
})

/**
 * 新增停车券
 */
const addParkCoupon = (data) => axios({
  url: 'park/coupon',
  method: 'post',
  data
})

/**
 * 编辑停车券
 */
const setParkCoupon = (data) => axios({
  url: 'park/coupon',
  method: 'put',
  data
})

/**
 * 停车券详情
 */
const getParkCouponDetails = (uuid) => axios({
  url: `park/coupon/${uuid}`
})

/**
 * 删除停车券
 */
const deleteParkCoupon = (uuid) => axios({
  url: `park/coupon/${uuid}`,
  method: 'delete'
})

export {
  getParkList,
  getParkExcel,
  getParkCouponList,
  getParkCouponExcel,
  getParkDetails,
  postParkCoupon,
  addParkCoupon,
  setParkCoupon,
  getParkCouponDetails,
  deleteParkCoupon
}
